/**
 * Font links HTML generator — produces <link> tags for Google Fonts
 */
import { fontStacks } from '@/data/font-stacks';

export function generateFontLinksHTML(settings: any): string {
  try {
    const stack =
      fontStacks[settings.fontStack as keyof typeof fontStacks]
        ? fontStacks[settings.fontStack as keyof typeof fontStacks]
        : fontStacks.system;
    const href = stack?.googleFontsHref || '';
    if (!href) return '';
    return `  <!-- Fonts -->\n  <link rel="preconnect" href="https://fonts.googleapis.com">\n  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>\n  <link href="${href}" rel="stylesheet">`;
  } catch {
    return '';
  }
}
